export const SALESDETAIL_LOADING = "SALESDETAIL_LOADING";
export const SALESDETAIL_RESET = "SALESDETAIL_RESET";
export const GET_SALESDETAIL = "GET_SALESDETAIL";
export const GET_SALESDETAIL_SUCCESS = "GET_SALESDETAIL_SUCCESS";
export const GET_SALESDETAIL_FAIL = "GET_SALESDETAIL_FAIL";
export const DELETE_SALESDETAIL = "DELETE_SALESDETAIL"
export const DELETE_SALESDETAIL_SUCCESS = "DELETE_SALESDETAIL_SUCCESS"
export const DELETE_SALESDETAIL_FAIL = "DELETE_SALESDETAIL_FAIL"
export const UPDATE_SALESDETAIL = "UPDATE_SALESDETAIL"
export const UPDATE_SALESDETAIL_SUCCESS = "UPDATE_SALESDETAIL_SUCCESS"
export const UPDATE_SALESDETAIL_FAIL = "UPDATE_SALESDETAIL_FAIL"
export const ADD_NEW_SALESDETAIL = "ADD_NEW_SALESDETAIL"
export const ADD_SALESDETAIL_SUCCESS = "ADD_SALESDETAIL_SUCCESS"
export const ADD_SALESDETAIL_FAIL = "ADD_SALESDETAIL_FAIL"